(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('SiteLocationDialogController', SiteLocationDialogController);

    SiteLocationDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'SiteLocation'];

    function SiteLocationDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, SiteLocation) {
        var vm = this;

        vm.siteLocation = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.siteLocation.id !== null) {
                SiteLocation.update(vm.siteLocation, onSaveSuccess, onSaveError);
            } else {
                SiteLocation.save(vm.siteLocation, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('dialysisApp:siteLocationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
